// Import necessary modules and hooks from React and React Router
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";

export const ProtectedRoute = ({ redirectPath = '/login' }) => {
    const { user } = useAuthContext();

    const [token, setToken] = useState(localStorage.getItem('nova_videowall_accessToken'));

    useEffect(() => {
        if (!localStorage.getItem('nova_videowall_accessToken')) {
            setToken(null);
        }
    }, [user]);

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
};